import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { PlayerProvider } from '@/contexts/PlayerContext';
import Header from '@/components/Header';
import AudioPlayer from '@/components/AudioPlayer';
import AdminLayout from '@/components/AdminLayout';
import LandingPage from '@/pages/LandingPage';
import SchedulePage from '@/pages/SchedulePage';
import ShowsPage from '@/pages/ShowsPage';
import ShowDetailsPage from '@/pages/ShowDetailsPage';
import DedicationWallPage from '@/pages/DedicationWallPage';
import CatchUpPage from '@/pages/CatchUpPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminEpisodes from '@/pages/AdminEpisodes';
import AdminShows from '@/pages/AdminShows';
import AdminSchedule from '@/pages/AdminSchedule';
import AdminHosts from '@/pages/AdminHosts';
import AdminUsers from '@/pages/AdminUsers';
import AdminRequests from '@/pages/AdminRequests';
import AdminSettings from '@/pages/AdminSettings';
import AdminSubmissions from '@/pages/AdminSubmissions';
import AdminTakedowns from '@/pages/AdminTakedowns';
import SubmitMusicPage from '@/pages/SubmitMusicPage';
import TakedownPage from '@/pages/TakedownPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import CookiePolicyPage from '@/pages/CookiePolicyPage';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';
import AdSenseLoader from '@/lib/adsense';
import FooterAdBar from '@/components/FooterAdBar';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#171A21',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#F8FAFC',
              },
            }}
          />
          <Header />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/shows" element={<ShowsPage />} />
            <Route path="/shows/:showId" element={<ShowDetailsPage />} />
            <Route path="/dedications" element={<DedicationWallPage />} />
            <Route path="/catchup" element={<CatchUpPage />} />
            <Route path="/submit-music" element={<SubmitMusicPage />} />
            <Route path="/takedown" element={<TakedownPage />} />

            {/* Legal */}
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            
            {/* Redirects for removed public routes */}
            <Route path="/listen" element={<Navigate to="/" replace />} />
            <Route path="/playlists" element={<Navigate to="/" replace />} />
            
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="shows" element={<AdminShows />} />
              <Route path="schedule" element={<AdminSchedule />} />
              <Route path="hosts" element={<AdminHosts />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="requests" element={<AdminRequests />} />
              <Route path="episodes" element={<AdminEpisodes />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="submissions" element={<AdminSubmissions />} />
              <Route path="takedowns" element={<AdminTakedowns />} />
            </Route>
            
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <AudioPlayer />
          <Footer />
          <CookieBanner />
          <AdSenseLoader />
          <FooterAdBar />
        </BrowserRouter>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
